import { render, staticRenderFns } from "./PostDoc.vue?vue&type=template&id=1fb25166&scoped=true&"
import script from "./PostDoc.vue?vue&type=script&lang=js&"
export * from "./PostDoc.vue?vue&type=script&lang=js&"
import style0 from "./PostDoc.vue?vue&type=style&index=0&id=1fb25166&prod&lang=css&"
import style1 from "./PostDoc.vue?vue&type=style&index=1&id=1fb25166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb25166",
  null
  
)

export default component.exports